import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";
import { STRINGS } from "../../../strings";
import { Visit } from "../../../system/AppState/AppVisitsState";
import { translate } from "../../../translate";
import { VisitTravelTimes } from "./slides";
import { UseQueryResult } from "@tanstack/react-query";

export interface SlideStepProps {
  slideIndex: number;
  slideStepsCount: number;
  showSteps: boolean;
}

export interface SlideProps extends SlideStepProps {
  visit: Visit.Available;
  allCaregiversConfirmed: boolean;
  isBigScreen: boolean;
  travelTimesQuery: UseQueryResult<VisitTravelTimes, unknown> | null;
  onSignatureConfirmed: (isConfirmed: boolean) => void;
  onClickLocation: () => void;
}

export const SlideContainer = styled(motion.div)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  color: #283847;
`;

export const SlideAppListContainer = styled.div`
  padding: 8px 0;

  & .AppListItem {
    padding: 8px 0;
  }
`;

export const SlideTitle = styled.div`
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 120%;
  display: flex;
  align-items: center;
`;

export const SlideSubTitle = styled.div`
  padding-bottom: 8px;
  font-size: 12px;
`;

export const SlideHeader = styled.div``;

export const SlideInformationText = styled.div`
  margin-top: 16px;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;

export const SlideImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 -16px;

  flex-grow: 1;
  position: relative;
  svg {
    position: absolute;
    bottom: 0;
  }
`;

export const Slide = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-top: 32px;
`;

export const SlideStepLabel = ({ slideIndex, slideStepsCount }: SlideStepProps) => (
  <SlideSubTitle>
    {translate(STRINGS.SLIDE_STEP_X_OF_COUNT)
      .replace("%step%", `${slideIndex}`)
      .replace("%steps_count%", `${slideStepsCount}`)}
  </SlideSubTitle>
);
